import cx from "classnames";
import type { Element } from "React";
import "./IconBetDrawer.scss";
type Props = {
  className?: string;
};

const IconBetDrawer = (props: Props): Element<"svg"> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={cx(props.className, "icon__icon-bet-drawer")}
  >
    <title id="title">Bet Drawer</title>
    <path d="M11.91 4.764L4.953 8.91l6.957 4.145 6.956-4.145-6.956-4.146zm0-1.164l8.91 5.31-8.91 5.31L3 8.91l8.91-5.31z" />
    <path d="M12.421 16.36h-1.023l.512-.305.511.305zm6.445-4.45h1.953l-8.91 5.31L3 11.91h1.953l6.957 4.145 6.956-4.145zm-6.445 4.45h-1.023l.512-.305.511.305zm-.511-.305l6.956-4.145h1.953l-8.91 5.31L3 11.91h1.953l6.957 4.145z" />
    <path d="M12.421 19.36h-1.023l.512-.305.511.305zm6.445-4.45h1.953l-8.91 5.31L3 14.91h1.953l6.957 4.145 6.956-4.145zm-6.445 4.45h-1.023l.512-.305.511.305zm6.445-4.45h1.953l-8.91 5.31L3 14.91h1.953l6.957 4.145 6.956-4.145z" />
  </svg>
);

export default IconBetDrawer;
